import React, { Suspense, lazy, useRef } from 'react'
import { appName, correctionalFacilityId } from '@fs/zion-config'
import { useFeatureFlag } from '@fs/zion-flags'
import { useHidePromo } from './hooks/useHidePromo'
import { PROMO_FLAG } from './constants'

const RootstechPromoOverlay = lazy(() => import('./RootstechPromo'))

// Facade for lazy loading the promo component
export default function RootstechPromo() {
  // Stable date reference — Harness evaluates the flag against this date but it only needs to be
  // captured once at mount time, not recreated on every render.
  const dateRef = useRef(new Date())
  // bandwidth : 'root' is a dummy value for Split so that the flag evaluates to 'on'. The real value is set in the RootstechPromo component
  const { isOn, config } = useFeatureFlag(PROMO_FLAG, { appName, date: dateRef.current, bandwidth: 'root' })
  const [isHidden, hide] = useHidePromo()

  // Do not show the promo in correctional facilities
  if (correctionalFacilityId) return null

  return isOn && !isHidden ? (
    <Suspense fallback={null}>
      <RootstechPromoOverlay key={config?.url} hide={hide} />
    </Suspense>
  ) : null
}
